import { render } from "./SmartFormRepeater.vue?vue&type=template&id=1f8c9d5a&ts=true"
import script from "./SmartFormRepeater.vue?vue&type=script&lang=ts"
export * from "./SmartFormRepeater.vue?vue&type=script&lang=ts"

import exportComponent from "/buddy/uup/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__